import { Link } from 'react-router-dom';
import { useDarkHero } from '@/contexts/NavbarContext';

const features = [
  { icon: 'ri-shopping-bag-line', title: 'Amazon Mağaza Yönetimi', desc: 'Amazon pazaryerinde online mağaza işletmeciliği yapmak isteyen yatırımcılar için özel hizmet.' },
  { icon: 'ri-graduation-cap-line', title: 'Eğitim ve Danışmanlık', desc: 'Amazon online ticaret üzerine verilen eğitim ve destekler ile mağaza işletmeciliğini kolaylaştırıyoruz.' },
  { icon: 'ri-line-chart-line', title: 'Mağaza Optimizasyonu', desc: 'Mağaza sahiplerinin en yüksek faydaya sahip olması amacıyla sürekli optimizasyon yapıyoruz.' },
  { icon: 'ri-settings-3-line', title: 'Teknik Altyapı', desc: 'E-ticaret altyapısı ve ödeme entegrasyonu ile mağazanızı hızla hayata geçiriyoruz.' },
  { icon: 'ri-customer-service-2-line', title: 'Uzman Kadro', desc: 'Uzman kadromuz ile Amazon pazaryerinde online mağaza işletmeciliği yapmanıza destek oluyoruz.' },
  { icon: 'ri-global-line', title: 'Global Erişim', desc: 'Dünyanın her yerindeki müşterilere ulaşmanızı sağlayan global e-ticaret çözümleri.' },
];

const benefits = [
  { icon: 'ri-time-line', title: 'Zaman Tasarrufu', desc: 'Mağaza yönetimini bize bırakın, siz işinize odaklanın.' },
  { icon: 'ri-bar-chart-line', title: 'Satış Artışı', desc: 'Optimizasyon ve stratejilerle satışlarınızı artırıyoruz.' },
  { icon: 'ri-shield-check-line', title: 'Güvenli Yatırım', desc: 'Uzman ekibimizle risksiz Amazon yatırımı yapın.' },
];

export default function OnlineMagazaPage() {
  useDarkHero(true);
  return (
    <main className="min-h-screen" style={{ background: 'var(--bg)' }}>
      {/* Hero */}
      <section className="relative min-h-[680px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=amazon%20online%20marketplace%20concept%20with%20digital%20storefront%20interface%2C%20glowing%20product%20listings%20on%20dark%20background%2C%20shopping%20cart%20icons%2C%20global%20e-commerce%20visualization%2C%20orange%20and%20dark%20navy%20color%20scheme%2C%20futuristic%20retail%20technology%2C%20cinematic%20digital%20art%20style&width=1920&height=680&seq=onlinemagaza-hero-01&orientation=landscape"
            alt="Online Mağaza"
            loading="eager"
            fetchPriority="high"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(105deg, rgba(8,10,20,0.92) 0%, rgba(12,18,38,0.80) 55%, rgba(8,10,20,0.50) 100%)' }} />
        </div>

        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 right-20 w-80 h-80 rounded-full" style={{ background: 'var(--orange)', filter: 'blur(120px)' }} />
        </div>

        <div className="w-full max-w-6xl mx-auto px-6 lg:px-10 relative z-10 pt-36 pb-24">
          <div className="flex items-center gap-2 mb-8">
            <Link to="/hizmetler" className="text-sm hover:opacity-80 transition-opacity" style={{ color: 'rgba(255,255,255,0.55)', textDecoration: 'none' }}>Hizmetler</Link>
            <i className="ri-arrow-right-s-line" style={{ color: 'rgba(255,255,255,0.35)', fontSize: 14 }} />
            <span className="text-sm font-medium" style={{ color: 'var(--orange)' }}>Online Mağaza</span>
          </div>

          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-16">
            <div className="flex-1">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6" style={{ background: 'rgba(232,97,26,0.18)', border: '1px solid rgba(232,97,26,0.45)' }}>
                <i className="ri-shopping-bag-line" style={{ color: 'var(--orange)' }} />
                <span className="text-sm font-semibold" style={{ color: 'var(--orange)' }}>Online Mağaza</span>
              </div>

              <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                Amazon&apos;da<br />
                <span style={{ color: 'var(--orange)' }}>Online Mağaza Aç</span>
              </h1>

              <p className="text-lg mb-8" style={{ color: 'rgba(255,255,255,0.82)', lineHeight: 1.8, maxWidth: 560 }}>
                Uzman kadromuz ile Amazon pazaryerinde online mağaza işletmeciliği yapmak isteyen yatırımcılar için kapsamlı hizmet sunuyoruz. Eğitim, danışmanlık ve tam yönetim desteği.
              </p>

              <div className="flex flex-wrap gap-4">
                <Link to="/iletisim" className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-semibold text-white cursor-pointer whitespace-nowrap hover:opacity-90 transition-opacity" style={{ background: 'var(--orange)', textDecoration: 'none' }}>
                  <i className="ri-mail-send-line" />Teklif Al
                </Link>
                <a href="tel:+908502420822" className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-semibold cursor-pointer whitespace-nowrap hover:opacity-80 transition-opacity" style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.28)', color: 'white', textDecoration: 'none' }}>
                  <i className="ri-phone-line" />0850 242 0 822
                </a>
              </div>
            </div>

            <div className="flex-shrink-0 grid grid-cols-2 gap-3">
              {[{ val: 'Amazon', lbl: 'Pazaryeri' }, { val: 'Uzman', lbl: 'Kadro' }, { val: 'Tam', lbl: 'Destek' }, { val: '7/24', lbl: 'Erişim' }].map((s, i) => (
                <div key={i} className="text-center px-8 py-6 rounded-2xl" style={{ background: 'rgba(255,255,255,0.09)', border: '1px solid rgba(255,255,255,0.18)', backdropFilter: 'blur(12px)' }}>
                  <div className="text-2xl font-bold mb-1" style={{ color: 'var(--orange)' }}>{s.val}</div>
                  <div className="text-xs" style={{ color: 'rgba(255,255,255,0.65)' }}>{s.lbl}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-14" style={{ background: 'var(--surface)', borderBottom: '1px solid var(--border)' }}>
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {benefits.map((b, i) => (
              <div key={i} className="flex items-start gap-4 p-6 rounded-2xl" style={{ background: 'var(--bg)', border: '1px solid var(--border)' }}>
                <div className="w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0" style={{ background: 'rgba(232,97,26,0.1)' }}>
                  <i className={`${b.icon} text-xl`} style={{ color: 'var(--orange)' }} />
                </div>
                <div>
                  <h3 className="font-bold text-sm mb-1" style={{ color: 'var(--text1)' }}>{b.title}</h3>
                  <p className="text-xs leading-relaxed" style={{ color: 'var(--text3)' }}>{b.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features + Image */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="flex flex-col lg:flex-row gap-14 items-center mb-16">
            <div className="flex-1">
              <h2 className="text-3xl font-bold mb-4" style={{ color: 'var(--text1)' }}>Hizmet Kapsamı</h2>
              <p className="text-sm leading-relaxed mb-4" style={{ color: 'var(--text3)' }}>
                Amazon online ticaret üzerine verilen eğitim ve destekler ile mağaza işletmeciliğinin daha güncel ve konforlu olması sağlanarak mağaza sahiplerinin en yüksek faydaya sahip olması amaç edinilmiştir.
              </p>
              <p className="text-sm leading-relaxed mb-6" style={{ color: 'var(--text3)' }}>
                Uzman kadromuz ile Amazon pazaryerinde online mağaza işletmeciliği yapmak isteyen fakat gerek zaman gerekse de beceri gibi nedenlerle Amazon online mağaza işletmesi yapamayacağını düşünen yatırımcılar için verilen hizmettir.
              </p>
              <p className="text-sm font-semibold" style={{ color: 'var(--text2)' }}>
                Destek hattı: <a href="tel:+908502420822" style={{ color: 'var(--orange)' }}>0850 242 0 822</a> – <a href="mailto:cs@cargonet.com.tr" style={{ color: 'var(--orange)' }}>cs@cargonet.com.tr</a>
              </p>
            </div>
            <div className="flex-shrink-0 w-full lg:w-[420px] h-[280px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=entrepreneur%20working%20on%20laptop%20managing%20online%20store%2C%20amazon%20seller%20dashboard%20on%20screen%2C%20modern%20home%20office%20setup%2C%20warm%20natural%20lighting%2C%20product%20boxes%20in%20background%2C%20successful%20e-commerce%20business%2C%20professional%20lifestyle%20photography&width=420&height=280&seq=onlinemagaza-content-01&orientation=landscape"
                alt="Online mağaza yönetimi"
                loading="lazy"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((f, i) => (
              <div key={i} className="p-6 rounded-2xl" style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}>
                <div className="w-12 h-12 flex items-center justify-center rounded-xl mb-4" style={{ background: 'rgba(232,97,26,0.1)' }}>
                  <i className={`${f.icon} text-xl`} style={{ color: 'var(--orange)' }} />
                </div>
                <h3 className="font-bold text-sm mb-2" style={{ color: 'var(--text1)' }}>{f.title}</h3>
                <p className="text-xs leading-relaxed" style={{ color: 'var(--text3)' }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20" style={{ background: 'var(--surface)', borderTop: '1px solid var(--border)' }}>
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-2xl font-bold mb-3" style={{ color: 'var(--text1)' }}>Online Mağaza İçin Teklif Alın</h2>
          <p className="mb-8 text-sm" style={{ color: 'var(--text3)' }}>Uzman ekibimiz en uygun çözümü sizin için hazırlasın.</p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/iletisim" className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold text-white cursor-pointer whitespace-nowrap" style={{ background: 'var(--orange)', textDecoration: 'none' }}>
              <i className="ri-mail-send-line" />Teklif Al
            </Link>
            <Link to="/hizmetler" className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold cursor-pointer whitespace-nowrap" style={{ background: 'var(--bg)', border: '1px solid var(--border)', color: 'var(--text1)', textDecoration: 'none' }}>
              <i className="ri-arrow-left-line" />Tüm Hizmetler
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
